// How long a make should be. Auto (the default, until the slider is touched) leaves it
// to the genie; the slider picks one of these, from short to long.
export const LENGTHS = [
  "short",
  "between short and medium",
  "medium",
  "between medium and long",
  "long",
];

// What a make asks for: nothing on Auto, so the genie picks a length that suits it
export const lengthRequested = ({ selectedLength, hasMoved }) =>
  hasMoved ? LENGTHS[Math.round(Number(selectedLength))] : undefined;

export default {
  name: "length",
  namespaced: true,
  state: {
    selectedLength: 2,
    // Moved means a length was picked; otherwise it's on Auto
    hasMoved: false,
  },
  mutations: {
    SET_SELECTED_LENGTH(state, payload) {
      state.selectedLength = payload;
    },
    SET_HAS_MOVED(state, payload) {
      state.hasMoved = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("SET_SELECTED_LENGTH", 2);
      commit("SET_HAS_MOVED", false);
    },
    moveSlider({ commit }, payload) {
      commit("SET_HAS_MOVED", true);
      commit("SET_SELECTED_LENGTH", payload);
    },
    setAuto({ commit }) {
      commit("SET_HAS_MOVED", false);
    },
  },
  modules: {},
  getters: {},
};
